import { render, staticRenderFns } from "./TP4.vue?vue&type=template&id=15d52df6&"
import script from "./TP4.vue?vue&type=script&lang=js&"
export * from "./TP4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports